<template>
  <el-dialog
    :model-value="visible"
    :title="title"
    width="420px"
    :close-on-click-modal="false"
    @update:model-value="$emit('update:visible', $event)"
  >
    <p class="text-sm text-slate-500 mb-3">
      将「{{ itemName }}」移动到目标文件夹
    </p>
    <div class="border border-slate-200 rounded p-3 max-h-64 overflow-y-auto">
      <FolderTreeSelector
        :nodes="treeData"
        :selected-id="targetFolderId"
        :exclude-id="excludeId"
        @select="targetFolderId = $event"
      />
    </div>
    <template #footer>
      <el-button @click="$emit('update:visible', false)">取消</el-button>
      <el-button
        type="primary"
        :disabled="!targetFolderId"
        :loading="submitting"
        @click="handleConfirm"
      >
        确定移动
      </el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref } from 'vue'
import FolderTreeSelector from './FolderTreeSelector.vue'

defineProps({
  visible: { type: Boolean, default: false },
  title: { type: String, default: '移动' },
  itemName: { type: String, default: '' },
  treeData: { type: Array, default: () => [] },
  excludeId: { type: [Number, String], default: null }
})

const emit = defineEmits(['update:visible', 'confirm'])

const targetFolderId = ref(null)
const submitting = ref(false)

function handleConfirm() {
  if (!targetFolderId.value) return
  emit('confirm', targetFolderId.value)
}
</script>
